import React from 'react'
import NameTypeBadge from './NameTypeBadge'
import { CopyFieldTemplate } from 'components/common'

/**
 * Body template for displaying contributor name with name type badge and copy button
 * @param {Object} props
 * @param {Object} props.rowData - The row data object
 * @param {string} props.field - The field name to display
 * @returns JSX element with badge, name and copy button
 */
const ContributorNameBodyTemplate = ({ rowData, field }) => {
    return (
        <div className="d-flex align-items-center">
            <span className="me-2">
                <NameTypeBadge
                    nameType={rowData.contributorNameType}
                    nameTypeId={rowData.contributorNameTypeId}
                />
            </span>
            {CopyFieldTemplate(rowData, field)}
        </div>
    )
}

export default ContributorNameBodyTemplate
